import React from 'react';
// import "../../assets/css/master.css";

import TemplateDashboard from "../../components/TemplateDashboard";
import PlantillasPermisosContent from './components/PlantillasPermisosContent';

const PlantillasPermisos = () => {

    return (
        <>

            <TemplateDashboard>
                <PlantillasPermisosContent />
            </TemplateDashboard>

        </>
    )
};

export default PlantillasPermisos;